<template>
  <div>
    <div id="body">
      <div class="wrapper">
        <div class="usercenter">
          <UserLeftGuid menuActive=""></UserLeftGuid>

          <div class="main">
            <div class="title">
              <h2>
                <svg
                  t="1653550410309"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2364"
                  width="64"
                  height="64"
                >
                  <path
                    d="M561.71026963 133.50290015a77.6722963 77.6722963 0 0 1 9.96794429 9.96794429L719.12612386 320.40833539l162.64578845-120.10726042a77.6722963 77.6722963 0 0 1 121.50536177 81.29700386L848.57995022 900.36148148H175.42004978L20.72272592 281.62396918a77.6722963 77.6722963 0 0 1 121.50536177-81.32289421L304.87387614 320.40833539l147.44790994-176.93749095a77.6722963 77.6722963 0 0 1 109.41437391-9.96794429zM512 193.18111406l-194.33608533 233.22401542-221.57317098-163.62963793L236.05622162 822.68918518h551.88755676l139.96547793-559.91369363-221.57317098 163.62963793L512 193.18111406z m181.23535762 486.22857483v82.85044978H330.76464238v-82.85044978h362.47071524z"
                    p-id="2365"
                  ></path>
                </svg>
                支付成功
              </h2>
            </div>
            <div class="box">
              <div class="box-content" v-loading="loading">
                <div class="pay-ok">
                  <img src="~@/assets/images/pay-ok.png" alt="" />
                  <h4>恭喜支付成功</h4>
                  <p>
                    成功下单支付
                    <strong>￥{{ payMoney }}</strong>
                    ！
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserLeftGuid from "../../components/user/left_guid.vue";
import { axiosRequest, axiosOptions } from "../../util/request";
import moment from "moment";

export default {
  components: { UserLeftGuid },
  data() {
    return {
      loading: false,
      payMoney: this.$route.query.total_amount || 0,
    };
  },
  created() {
    axiosRequest(
      "/user/user-formation",
      { t: Date.now() },
      axiosOptions("get", "", "json")
    ).then((res) => {
      if (res.data && res.data.code == 200) {
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        userInfo.id = res.data.data.id;
        userInfo.username = res.data.data.username;
        userInfo.headPhoto = res.data.data.headPhotoUrl;
        userInfo.integral = res.data.data.integral;
        userInfo.freeIntegral = res.data.data.freeIntegral;
        userInfo.vipType = res.data.data.vipType;
        userInfo.vipTime = res.data.data.vipTime;
        userInfo.workbenchAccess = res.data.data.workbenchAccess;
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
        this.$store.commit("setUserInfo", userInfo);
      } else {
        this.$message.error("获取信息失败，请稍后刷新页面重试");
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/usercenter.scss";
.intro {
  margin-bottom: 15px;
  font-size: $fontSizeSmall;
  font-weight: bold;
  line-height: 30px;
  color: #595959;
  .avatar {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    border-radius: 30px;
    vertical-align: -10px;
  }
  strong {
    margin: 0 5px;
    color: #ffc001;
  }
}
.adv {
  margin-bottom: 50px;
  img {
    width: 100%;
  }
}
.type-select {
  margin-bottom: 35px;
  text-align: center;
  .el-radio {
    width: 245px;
    height: 160px;
    padding: 25px;
    border: 1px solid #e5e5e5;
    vertical-align: top;
    &.is-checked {
      border: 2px solid #ff5a00;
      box-shadow: 0 5px 10px rgba(255, 90, 0, 0.2);
      ::v-deep {
        .el-radio__label {
          &:before {
            position: absolute;
            right: 3px;
            bottom: 2px;
            width: 13px;
            height: 13px;
            font-family: element-icons !important;
            font-size: 16px;
            color: #fff;
            z-index: 1;
            content: "";
          }
          &:after {
            position: absolute;
            right: 0;
            bottom: 0;
            border-width: 13px;
            border-style: solid;
            border-color: transparent #ff5a00 #ff5a00 transparent;
            content: "";
          }
        }
      }
    }
    &.y {
      &:before {
        position: absolute;
        left: -2px;
        top: -13px;
        width: 48px;
        height: 27px;
        background: url(~@/assets/images/pay-type-sp1.png) no-repeat;
        content: "";
      }
      &:after {
        position: absolute;
        right: 17px;
        top: 0px;
        width: 34px;
        height: 34px;
        background: url(~@/assets/images/pay-type-sp2.png) no-repeat;
        content: "";
      }
    }
    &.s {
      ::v-deep {
        .el-radio__label {
          > span.name {
            color: #e8a203;
          }
        }
      }
    }
    &.m {
      ::v-deep {
        .el-radio__label {
          > span.name {
            color: #666666;
          }
        }
      }
    }
    ::v-deep {
      .el-radio__input {
        display: none;
      }
      .el-radio__label {
        display: block;

        > span {
          display: block;
          &.price {
            height: 60px;
            margin-bottom: 10px;
            font-size: 36px;
            font-weight: bold;
            color: #ff3f15;
            line-height: 54px;
            border-bottom: 1px dashed #c8c9cc;
            small {
              font-size: 18px;
              font-weight: normal;
              color: #333333;
              vertical-align: 2px;
              del {
                vertical-align: -2px;
              }
            }
            sub {
              font-size: 14px;
              font-weight: normal;
              color: #333333;
              vertical-align: 1px;
              span {
                color: #ff3f15;
              }
            }
          }
          &.name {
            font-size: 16px;
            line-height: 30px;
            color: #f70f36;
            img {
              margin-right: 5px;
              vertical-align: -2px;
            }
          }
        }
      }
    }
  }
}
.border {
  padding: 25px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 5px;
  .submit {
    margin: 40px 0 0;
    border: 0;
    .el-button {
      width: 184px;
      height: 45px;
      font-size: 18px;
      background-color: #68bf7b !important;
      border-color: #68bf7b !important;
      border-radius: 50px;
    }
  }
}
.amount {
  margin-bottom: 40px;
  font-size: 16px;
  color: #262626;
  strong {
    font-size: 24px;
    color: #ff3900;
  }
}
.pay-select {
  .el-radio {
    img {
      vertical-align: middle;
    }
  }
  ::v-deep {
    .el-radio__input.is-checked {
      .el-radio__inner:after {
        background-color: #68bf7b;
      }
    }
    .el-radio__inner {
      width: 22px;
      height: 22px;
      background-color: #fff;
      border-color: #68bf7b;
      &:after {
        width: 10px;
        height: 10px;
      }
    }
  }
}
.tip {
  margin-top: 60px;
  text-align: left;
}
.pay-ok {
  padding: 20px;
  text-align: center;
  line-height: 50px;
  img {
    margin-bottom: 30px;
    margin-right: -33px;
  }
  h4 {
    font-size: 30px;
    font-weight: bold;
  }
  p {
    font-size: 18px;
    strong {
      color: #ff0000;
    }
  }
}
</style>
